/**
 * My API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ReportCurrentPrevious } from './reportCurrentPrevious';


export interface ReportMachineUtilizationAvgPerDay { 
    production?: ReportCurrentPrevious;
    standby?: ReportCurrentPrevious;
    cip?: ReportCurrentPrevious;
    startup?: ReportCurrentPrevious;
    standstill?: ReportCurrentPrevious;
    slowing_down?: ReportCurrentPrevious;
}

